import { Instagram, Facebook, Castle } from "lucide-react";
import { SeasonProvider, useSeasonContext } from "@/contexts/SeasonContext";

const FooterContent = () => {
  const currentYear = new Date().getFullYear();
  const { isSummer } = useSeasonContext();

  // Définition de la couleur de survol selon la saison
  const hoverClass = isSummer
    ? "active:text-summer-accent md:hover:text-summer-accent"
    : "active:text-ochre-light md:hover:text-ochre-light";

  return (
    <footer className="bg-warm-brown text-cream/80 py-10 md:py-12">
      <div className="container-narrow">
        {/* Footer principal */}
        <div className="flex flex-col gap-8 md:flex-row md:justify-between md:items-start">
          {/* Colonne gauche : Logo et Description */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <div className="flex items-center gap-3 flex-wrap justify-center md:justify-start">
              {/* LIEN LOGO VERS ACCUEIL */}
              <a href="/" className="transition-opacity hover:opacity-80" aria-label="L'Ostrea - Retour à l'accueil">
                <h3 className="text-xl md:text-2xl text-cream" style={{ fontFamily: "Cinzel, serif" }}>
                  L'Ostréa
                </h3>
              </a>

              <div className="flex items-center gap-2">
                <a
                  href="https://www.instagram.com/lostreadegustation/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`p-2 -m-2 ${hoverClass} transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center`}
                  aria-label="Instagram"
                >
                  <Instagram size={22} />
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61556260289003#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`p-2 -m-2 ${hoverClass} transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center`}
                  aria-label="Facebook"
                >
                  <Facebook size={22} />
                </a>
              </div>
            </div>
            <p className="text-sm mt-2 leading-relaxed max-w-xs">
              Guinguette conviviale à l'environnement unique
            </p>
          </div>

          {/* Colonne droite : Liens */}
          <div className="flex flex-col items-center md:items-end gap-1 text-center md:text-right">
            <a
              href="/mentions-legales"
              className={`text-sm py-2 md:py-0 ${hoverClass} transition-colors min-h-[44px] md:min-h-0 flex items-center justify-center`}
            >
              Mentions légales
            </a>
            <a
              href="/politique-de-confidentialite"
              className={`text-sm py-2 md:py-0 ${hoverClass} transition-colors min-h-[44px] md:min-h-0 flex items-center justify-center`}
            >
              Politique de confidentialité
            </a>
            <a
              href="https://www.roquetaillade.eu"
              target="_blank"
              rel="noopener noreferrer"
              className={`flex items-center justify-center gap-2 text-sm py-2 md:py-0 ${hoverClass} transition-colors min-h-[44px] md:min-h-0`}
            >
              <Castle size={18} />
              <span className="leading-tight">Château Fort de Roquetaillade</span>
            </a>
            {/* LIGNE PHOTOGRAPHE ALIGNÉE SUR LE STYLE DES AUTRES LIENS */}
            <a
              href="https://www.instagram.com/com_aude?igsh=eWJlOGhlbG4xcHVw"
              target="_blank"
              rel="noopener noreferrer"
              className={`flex items-center justify-center gap-2 text-sm py-2 md:py-0 ${hoverClass} transition-colors min-h-[44px] md:min-h-0`}
            >
              <Instagram size={18} />
              <span className="leading-tight">Crédit photo : com_aude</span>
            </a>
          </div>
        </div>

        {/* Bas du footer */}
        <div className="border-t border-cream/10 mt-8 pt-8 text-center">
          <p className="text-sm text-cream/60">© {currentYear} L'Ostréa. Tous droits réservés.</p>
          <a
            href="https://fabienwebdesign.com"
            target="_blank"
            rel="noopener noreferrer"
            className={`text-xs text-cream/40 ${hoverClass} transition-colors mt-2 inline-flex items-center justify-center py-2 min-h-[44px]`}
          >
            Créé par FabienWebDesign
          </a>
        </div>
      </div>
    </footer>
  );
};

const Footer = () => {
  return (
    <SeasonProvider>
      <FooterContent />
    </SeasonProvider>
  );
};

export default Footer;
